import { lazy } from 'react';

// project imports

import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('components/admin/dashboard/Default')));

// satish routing
const CategoryPage = Loadable(lazy(() => import('components/admin/category')));
const CategoryAddPage = Loadable(lazy(() => import('components/admin/category/category')));
const ProductPage = Loadable(lazy(() => import('components/admin/product')));
const ProductAddPage = Loadable(lazy(() => import('components/admin/product/product')));
const UserPage = Loadable(lazy(() => import('components/admin/user')));
const UserAddPage = Loadable(lazy(() => import('components/admin/user/user')));
 
const AddBuyer = Loadable(lazy(() => import('components/admin/user/add-buyer')));
const BuyerListing = Loadable(lazy(() => import('components/admin/user/buyer-listing')));
const AddSeller = Loadable(lazy(() => import('components/admin/user/add-seller')));
const SellerListing = Loadable(lazy(() => import('components/admin/user/seller-listing')));
const OrderList = Loadable(lazy(() => import('components/admin/order/index')));
const AdminOrderDetail = Loadable(lazy(() => import('components/admin/order/adminOrderDetails')));
const Settings = Loadable(lazy(() => import('components/admin/setting/index')));

const AdminTransportOrders = Loadable(lazy(() => import('components/admin/order/adminTransportOrders')));
const AdminReservationDetails = Loadable(lazy(() => import('components/admin/order/adminreservationdetails')));
const AddTransporter = Loadable(lazy(() => import('components/admin/user/add-transporter')));
const TransporterListing = Loadable(lazy(() => import('components/admin/user/transporter-listing')));
const AddOrderer = Loadable(lazy(() => import('components/admin/user/add-orderer')));
const OrdererListing = Loadable(lazy(() => import('components/admin/user/orderer-listing')));
// ==============================|| MAIN ROUT ING ||============================== //
   
const MainRoutes = {

  
  
  path: '/',
  element: <MainLayout />,
  children: [
    
    
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        }
      ]
    },
    
    {
      path: 'category/form',
      element: <CategoryAddPage />
    },
      
    {
      path: 'category/form/:id',
      element: <CategoryAddPage />
    },
    {
      path: 'category',
      element: <CategoryPage />
    }, 

    {
      path: 'product/form',
      element: <ProductAddPage />
    },
    {
      path: 'product/form/:id',
      element: <ProductAddPage />
    },
    {
      path: 'product',
      element: <ProductPage />
    },
    {
      path: 'user',
      element: <UserPage />
    },
    {
      path: 'user/form',
      element: <UserAddPage />
    },
    {
      path: 'user/form/:id',
      element: <UserAddPage />
    },
    {
      path: 'buyer',
      element: <BuyerListing />
    },
    {
      path: 'buyer/form',
      element: <AddBuyer />
    },
    {
      path: 'buyer/form/:id',
      element: <AddBuyer />
    },
    {
      path: 'seller',
      element: <SellerListing />
    },
    {
      path: 'seller/form',
      element: <AddSeller />
    },
    {
      path: 'seller/form/:id',
      element: <AddSeller />
    },
    {
      path: "orderlist",
      element: <OrderList />,
    },
    {
      path: "adminorderdetails/:id",
      element: <AdminOrderDetail />,
    },
    {
      path: 'transporter',
      element: <TransporterListing />
    },
    {
      path: 'transporter/form',
      element: <AddTransporter />
    },
    {
      path: 'transporter/form/:id',
      element: <AddTransporter />
    },
    {
      path: 'orderer',
      element: <OrdererListing />
    },
    {
      path: 'orderer/form',
      element: <AddOrderer />
    },
    {
      path: 'orderer/form/:id',
      element: <AddOrderer />
    },
    {
      path: "reservationlist",
      element: <AdminTransportOrders />,
    },
    {
      path: "adminreservationdetails/:id",
      element: <AdminReservationDetails />,
    },
    {
      path: "settings",
      element: <Settings />,
    },
    
  ]
};

export default MainRoutes;
